import { faBirthdayCake, faChampagneGlasses, faHeart, faSnowflake } from "@fortawesome/free-solid-svg-icons";

const gift_cards_config = [
  {
    type: "Birthday",
    title: "GIFT_CARD_BIRTHDAY",
    icon: faBirthdayCake,
    color: "text-indigo-600",
    background: "bg-indigo-400",
  },
  {
    type: "Anniversary",
    title: "GIFT_CARD_ANNIVERSARY",
    icon: faHeart,
    color: "text-red-600",
    background: "bg-red-400",
  },
  {
    type: "Congratulations",
    title: "CONGRATULATIONS",
    icon: faChampagneGlasses,
    color: "text-blue-600",
    background: "bg-blue-400",
  },
  {
    type: "Christmas",
    title: "GIFT_CARD_CHRISTMAS",
    icon: faSnowflake,
    color: "text-green-600",
    background: "bg-green-400",
  },
];

export default gift_cards_config;
